enum GRAPH_TYPE {
    RANGE = 'range',
    HOTELS = 'hotels',
}

export default GRAPH_TYPE;
